import { render, staticRenderFns } from "./BaselineAtlas.vue?vue&type=template&id=63213317"
import script from "./BaselineAtlas.vue?vue&type=script&lang=js"
export * from "./BaselineAtlas.vue?vue&type=script&lang=js"
import style0 from "./BaselineAtlas.vue?vue&type=style&index=0&id=63213317&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports